import { FC } from 'react';

import { IconProps } from '../types';

const WithNaturalSweetenerIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M26.8799 19.9927C26.8466 24.0099 26.9316 28.0102 26.9034 32"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9031 32C26.8942 33.2517 26.8742 34.5023 26.8359 35.7521"
      stroke="#030303"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9796 35.2856C15.4116 34.819 13.1791 33.6965 10.8008 32.2678C9.21038 30.9995 7.94096 29.7311 6.83204 27.9817C3.95762 23.3603 3.63661 18.2869 4.27862 13.199C7.53886 12.881 10.8693 12.9133 14 13.7173"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.0551 36C27.0551 36 47.1907 20.1385 27.0551 4C6.91952 20.1531 27.0551 36 27.0551 36Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WithNaturalSweetenerIcon;
